<template>
  <navBack></navBack>
  <view class="page">
    <t-tabs v-model="activeTab" @change="onTabsChange" class="custom-tabs">
      <t-tab-panel label="可用打折卡" value="0">
        <view class="body">
          <block v-for="(item) in dataList" :key="item._id">
            <cika-item-user :card-info="item" />
          </block>
          <t-empty v-if="dataList.length === 0" description="没有记录" />
        </view>
      </t-tab-panel>

      <t-tab-panel label="失效打折卡" value="1">
        <view class="body">
          <block v-for="(item) in dataList2" :key="item._id">
            <cika-item-user :card-info="item" />
          </block>
          <t-empty v-if="dataList2.length === 0" description="没有记录" />
        </view>
      </t-tab-panel>
    </t-tabs>
  </view>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import navBack  from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance();

const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
const auth = proxy.$auth;
 
const customer_Id = ref('')
// 响应式数据
const activeTab = ref('0')
const dataList = ref([])
const dataList2 = ref([])

// 标签页切换
const onTabsChange = (value) => {
  activeTab.value = value
  loadData()
}

// 加载数据
const loadData = async () => {
  await auth.signInAnonymously();
  const db = app.database();
  let queryData = {
    customerId: customer_Id.value,
    type: 3
  }

  if (activeTab.value === '0')

    queryData.status = 1;
  else
    queryData.status = -1;


 

  const res = await db.collection("my_customer_amount_log")
    .where(queryData)
    .orderBy('createAt.timeStamp', 'desc')
  
    .get();

 
 
  dataList.value = res.data;
}

// 组件挂载时加载数据
onMounted(() => {
  loadData()
})
</script>

<style scoped>
.page {
  height: 100%;
}

.body {
  padding: 20px;
}

.custom-tabs {
  height: 100%;
}

 
</style>